import { lightbox, getRem } from "./utlis.js";
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  Keyboard,
  Thumbs,
  FreeMode,
  Mousewheel,
  Autoplay,
} from "swiper/modules";

function stepsSlider() {
  if (document.querySelector(".steps-slider")) {
    const stepsPerView =
      document.querySelector(".steps-slider .swiper").dataset.sliderPerview ||
      5;
    const stepsSlider = new Swiper(".steps-slider .swiper", {
      modules: [Navigation, Pagination, Keyboard, Mousewheel, Autoplay],
      spaceBetween: 0,
      touchReleaseOnEdges: true,
      mousewheel: {
        releaseOnEdges: true,
        sensitivity: 1,
      },
      speed: 600,
      grabCursor: true,
      autoplay: {
        speed: 1000,
      },
      breakpoints: {
        1200: {
          slidesPerView: stepsPerView,
        },
        768: {
          slidesPerView: 3,
        },
        368: {
          slidesPerView: "auto",
        },
      },
    });
  }
}

export function initSliders() {
  stepsSlider();
}
